import { element, extend } from 'angular';
var LightboxService = (function () {
    function LightboxService($rootScope, $compile, $timeout) {
        this.$rootScope = $rootScope;
        this.$compile = $compile;
        this.$timeout = $timeout;
    }
    LightboxService.prototype.showPartial = function (pageUrl, args) {
        var _this = this;
        if (args === void 0) { args = {}; }
        var html = "\n      <div class=\"lightbox__container\">\n        <div class=\"lightbox__overlay\" ng-click=\"close()\"></div>\n        <div class=\"lightbox\" ng-include=\"'" + pageUrl + "'\" onload=\"finishLoading()\"></div>\n        <div ng-show=\"loading\" class=\"lightbox__preloader content-preloader content-preloader--40\" ng-cloak></div>\n      </div>\n    ";
        var lightboxContainer;
        var compiledHtml;
        this.$scope = this.$rootScope.$new();
        extend(this.$scope, args);
        this.$scope.loading = true;
        this.$scope.close = function () {
            lightboxContainer.remove();
        };
        this.$scope.finishLoading = function () {
            _this.$scope.loading = false;
        };
        compiledHtml = this.$compile(html)(this.$scope);
        element('.master__container').append(compiledHtml);
        lightboxContainer = element('.lightbox__container');
        this.$timeout(function () {
            _this.$scope.$apply();
        });
    };
    LightboxService.$inject = ['$rootScope', '$compile', '$timeout'];
    return LightboxService;
}());
export { LightboxService };
